var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!this.inline && this.unstable)?_c('div',{staticClass:"lspinner-unstable",class:_vm.classNames}):(this.inline && !this.unstable)?_c('div',{staticClass:"lspinner-inline",class:_vm.classNamesInline}):_c('div',[_vm._v("Conflict spinner")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b68488d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading/Spinner.vue
// module id = null
// module chunks = 